import React from 'react';
import isNil from 'lodash/isNil';
import Subscriber from 'views/EMR/components/Eligibility/Overview/Subscriber';
import Encounter from 'views/EMR/components/Eligibility/Overview/Encounter';
import Provider from 'views/EMR/components/Eligibility/Overview/Provider';
import Payer from 'views/EMR/components/Eligibility/Overview/Payer';
import Dependents from 'views/EMR/components/Eligibility/Overview/Dependents';
import Plan from 'views/EMR/components/Eligibility/Overview/Plan';
import RelatedEntities from 'views/EMR/components/Eligibility/Overview/RelatedEntities';
import Errors from 'views/EMR/components/Eligibility/Overview/Errors';
import {
  EligibilityOverview,
} from 'dtos/eligibilityOverview';

type Props = {
  overview?: EligibilityOverview;
};

export default function Overview({ overview }: Props) {
  const {
    subscriber,
    encounter,
    provider,
    payer,
    dependents,
    plan,
    relatedEntities,
    errors,
  } = overview ?? {};

  return (
    <div className="w-full flex-1 overflow-y-auto flex flex-col gap-4 p-4">
      {!isNil(errors) && errors.length > 0 && <Errors errors={errors} />}
      {!isNil(subscriber) && <Subscriber subscriber={subscriber} />}
      {!isNil(encounter) && <Encounter encounter={encounter} />}
      {!isNil(provider) && <Provider provider={provider} />}
      {!isNil(payer) && <Payer payer={payer} />}
      {!isNil(dependents) && dependents.length > 0 && (
        <Dependents dependents={dependents} />
      )}
      {!isNil(plan) && <Plan plan={plan} />}
      {!isNil(relatedEntities) && relatedEntities.length > 0 && (
        <RelatedEntities relatedEntities={relatedEntities} />
      )}
    </div>
  );
}
